/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Show_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Show previous event" |
*
* @param {Player_Show_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_show_previous_event = /** @type {((inputs?: Player_Show_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Show_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать предыдущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला कार्यक्रम दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar evento anterior")
	return /** @type {LocalizedString} */ ("Show previous event")
});